import React, { useEffect, useState, useRef } from 'react';
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { toast } from 'react-toastify';
import Toaster from './w-toaster';
import ButtonComp from './w-button';
import SVG from './w-svg';

interface DropDownProps {
  placeholder: any;
  selectedOption: any;
  options: any;
  isMulti: boolean;
  handleSelectChange: any;
  tabIndex?: any;
  minWidth?: any;
  Width?: any;
  size?: any;
  inputref?: any;
  handleAction?: any;
  percentage?: Boolean;
  handleBlurAction?: any;
  handleBlur?: any;
  textError?: any;
  id?: any;
  disabled?: any;
  isaddNewUser?: any;
  createGlobalUserAPI?: any;
  multiSelectOptionsList?: any;
  is_creatable?: any;
  className?: any;
  // create option
  isCreateButton?: any;
  openCreateStorageModal?: any;
  createLabel?: any;
  handleCreateButton?: any;

  regexType?: any;
  clearable?: boolean;
  minHeight?: any;
  hideOptions?: any;
  maxLength?: any;
  dropDownLabel?: any;
  maxHeight?: any;

  //Tags Creation
  createTagAPI?: any;
  isCreateTag?: any;
  showImage?: boolean;
  minLength?: number;
}

const DropDown: React.FC<DropDownProps> = ({
  placeholder,
  selectedOption,
  options,
  isMulti,
  handleSelectChange,
  tabIndex,
  minWidth,
  Width,
  inputref,
  handleAction,
  percentage,
  handleBlurAction,
  handleBlur,
  textError,
  id,
  disabled,
  isaddNewUser,
  createGlobalUserAPI,
  multiSelectOptionsList,
  is_creatable,
  className,
  isCreateButton,
  openCreateStorageModal,
  createLabel,
  handleCreateButton,
  regexType,
  clearable,
  minHeight,
  hideOptions,
  maxLength = Infinity,
  dropDownLabel,
  size = 'px',

  //tags creation
  isCreateTag,
  createTagAPI,
  showImage = false,
  minLength = 0,
  maxHeight,
}) => {
  const [colorsprimary, setColorsPrimary] = useState('rgb(32,80,136');
  const [colorsSecondary, setColorsSecondary] = useState('0,0,0');
  const [inputValue, setInputValue] = useState('');

  const regexPatterns = {
    Lowercase: /^[a-z]+$/, // Only lowercase letters
    Alphanumeric: /^[A-Za-z0-9_]+$/,
    AlphanumericWithHyphen: /^[A-Za-z0-9_-]+$/, // Alphanumeric with underscores
    LowercasewithNumeric: /^[a-z0-9_]+$/, // Lowercase and numeric with underscores
    Numeric: /^[0-9]+$/, // Numeric only
    Alphanumericwithfirstletter: /^[A-Za-z][A-Za-z0-9_]*$/, // Alphanumeric with only first letter as alphabet
    Lowercasewithfirstletter: /^[a-z][a-z0-9_]*$/, // Lowercase with only first letter as alphabet
    NumericWithDots: /^[0-9.]+$/, // Numeric only
  };

  const regex = regexPatterns[regexType] || null;

  const [regexError, setregexError] = useState('');

  const customFilter = (option, inputValue) => {
    const searchString = inputValue.toLowerCase();
    const searchInObject = (obj) => {
      if (!obj) return false;

      return Object.values(obj).some((value) => {
        if (typeof value === 'string') {
          return value.toLowerCase().includes(searchString);
        }
        if (typeof value === 'object') {
          return searchInObject(value);
        }
        return false;
      });
    };

    return searchInObject(option.data);
  };

  const CustomSingleValue = (props) => {
    const { data } = props;
    return (
      <components.SingleValue {...props}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {showImage && (
            <img
              src={data.image}
              alt={data.label}
              style={{
                width: 20,
                height: 20,
                marginRight: 8,
                borderRadius: '50%',
              }}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = '/asset/sourceImg/arivonix_icon.svg';
              }}
            />
          )}
          {data.label}
        </div>
      </components.SingleValue>
    );
  };

  const CustomMultiValue = (props) => {
    const { data } = props;
    return (
      <div className='border'>
        <components.MultiValue {...props}>
          <div
            style={{ display: 'flex', alignItems: 'center' }}
            className={
              (data?.diff ? 't-aqua ' : '') +
              (data.colourful ? 'error-text' : '')
            }
            title={
              data?.diff
                ? 'This user was added indirectly'
                : data?.colourful
                ? 'This Rule has been modified after association'
                : ''
            }
          >
            {showImage && (
              <img
                src={data.image}
                alt={data.label}
                style={{
                  width: 20,
                  height: 20,
                  marginRight: 8,
                  borderRadius: '50%',
                }}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = '/asset/sourceImg/arivonix_icon.svg';
                }}
              />
            )}
            {data.label}
          </div>
        </components.MultiValue>
      </div>
    );
  };

  const customNoOptionsMessage = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const handleAddClick = () => {
      if (emailRegex.test(inputValue)) {
        const userExists = multiSelectOptionsList.some(
          (user) => user.label === inputValue
        );

        if (userExists) {
          toast(
            <Toaster toastText={'This user already exists.'} closebtn={false} />
          );
        } else {
          createGlobalUserAPI(inputValue);
          setTimeout(() => {
            setInputValue('');
          }, 1000);
        }
      } else {
        toast(
          <Toaster
            toastText={'Invalid email format. Please enter a valid email.'}
            closebtn={false}
          />
        );
      }
    };

    if (isaddNewUser) {
      return (
        <>
          {multiSelectOptionsList.some((user) => user.label === inputValue) ? (
            <div>User already exists</div>
          ) : inputValue ? (
            <div
              className=' t-d'
              style={{
                padding: '0px 0px',
                cursor: 'pointer',
                textAlign: 'left',
              }}
              onClick={handleAddClick}
            >
              {`Add '${inputValue}'`}
            </div>
          ) : (
            <div className=''>No options available</div>
          )}
        </>
      );
    }
    return <div className=''>No options available</div>;
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (isaddNewUser && event.key === 'Enter' && inputValue) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailRegex.test(inputValue)) {
        const userExists = multiSelectOptionsList.some(
          (user) => user.label === inputValue
        );

        const optionAlreadySelected = Array.isArray(selectedOption)
          ? selectedOption.some((option) => option.label === inputValue)
          : selectedOption?.label === inputValue;

        if (!optionAlreadySelected) {
          createGlobalUserAPI(inputValue);
        }
      } else {
        toast(
          <Toaster
            toastText={'Invalid email format. Please enter a valid email.'}
            closebtn={false}
          />
        );
      }
    }
  };

  const CustomMenuList = (props) => {
    return (
      <components.MenuList {...props}>
        {props.children}
        {isCreateButton && (
          <div
            className='create-option-container'
            style={{
              padding: '5px',
              textAlign: 'center',
              // cursor: 'pointer',
              borderTop: '1px solid rgba(0, 0, 0, 0.1)',
            }}
            onClick={() => {
              handleCreateButton();
            }}
          >
            <ButtonComp
              buttonClass='btn py-1 px-4 text_caption_bold text-center rounded-1'
              ariaLabel={createLabel}
              label={createLabel}
              handleButtonClick={() => {
                handleCreateButton();
              }}
              tabIndex={0}
            />
          </div>
        )}
      </components.MenuList>
    );
  };

  const handleKeyDown = (e) => {
    if (e.key == 'Enter' && inputValue.trim() !== '') {
      const newOption = { label: inputValue.trim(), value: inputValue.trim() };
      let tempSelected = [];
      if (selectedOption) {
        const isDuplicate = selectedOption.some(
          (option) => option.value === newOption.value
        );
        tempSelected = [...selectedOption];
        if (!isDuplicate) {
          tempSelected.push(newOption);
        }
      } else {
        tempSelected.push(newOption);
      }
      handleSelected(tempSelected);
      setInputValue('');
      e.preventDefault();
    }
  };

  const handleSelected = (event) => {
    handleSelectChange(event);
    if (!handleBlur) {
      const activeElement = document.activeElement as HTMLElement;
      if (activeElement && activeElement.blur) {
        activeElement.blur();
      }
      setTimeout(() => {
        if (activeElement) {
          activeElement.focus();
        }
      }, 50);
    }
  };

  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'create-option') {
      if (inputValue?.length >= minLength && inputValue?.length <= maxLength) {
        createTagAPI(newValue);
        handleSelected(newValue);
      } else if (inputValue?.length < minLength) {
        setregexError(`Minimum length of ${minLength} characters required`);
      } else {
        toast(
          <Toaster
            toastText={`Maximum length of ${maxLength} characters exceeded`}
            closebtn={true}
          />
        );
      }
    } else {
      handleSelected(newValue);
    }
  };

  const handleFocus = (event) => {
    if (selectedOption && !isMulti) {
      setInputValue(selectedOption.label);
      event.stopPropagation();
      event.preventDefault();
    }
  };

  return (
    <>
      {regexError && (
        <div className='error-inlinetext mb-2' role='alert' aria-atomic='true'>
          {regexError}
        </div>
      )}
      {inputValue?.length > maxLength && (
        <div
          className='error-inlinetext mb-2'
          role='alert'
          aria-atomic='true'
        >{`Maximum length of ${maxLength} characters exceeded`}</div>
      )}
      <div
        className={
          'position-relative' + (inputValue?.length > maxLength ? ' pt-2' : '')
        }
      >
        {dropDownLabel && (
          <div className='position-absolute name_border_css'>
            <span className='t-d-59 text_caption_bold'>{dropDownLabel}</span>
          </div>
        )}
        <div className={' '}>
          <Select
            menuPortalTarget={document.body}
            filterOption={customFilter}
            onFocus={handleFocus}
            styles={{
              menuPortal: (baseStyles) => ({
                ...baseStyles,
                zIndex: 99999,
              }),
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused
                  ? !textError
                    ? '#2050ec'
                    : '#b3261e'
                  : !textError
                  ? `rgba(${colorsSecondary},0.5)`
                  : '#b3261e',
                minHeight: '10px', // Adjust the minHeight
                padding: '0px', // Adjust the padding
                minWidth: `${minWidth}px`,
                boxShadow: 'none',
                outline:
                  state.isFocused && !textError ? '1px solid #2050ec' : '0px',
                fontWeight: '500',
                width: !percentage ? `${Width}${size}` : `${Width}%`,
              }),
              valueContainer: (provided) => ({
                ...provided,
                maxHeight: `${maxHeight}px`,
                overflowY: 'auto',
                minHeight: minHeight ? `${minHeight}px` : '10px',
              }),
              menu: (provided) => ({
                ...provided,
                minHeight: '10px', // Adjust the minHeight
                padding: '0',
              }),
              multiValue: (styles) => ({
                ...styles,
                backgroundColor: `rgba(${colorsSecondary},0.05)`,
                borderRadius: '20px',
              }),
              singleValue: (styles) => ({
                ...styles,
                paddingInline: '0px',
                paddingBlock: '0px',
              }),
              indicatorsContainer: (styles) => ({
                ...styles,
                padding: '0px', // Adjust the padding
              }),
              dropdownIndicator: (styles) => ({
                ...styles,
                padding: '4px',
              }),
              clearIndicator: (styles) => ({
                ...styles,
                padding: '4px',
              }),
              multiValueLabel: (styles) => ({
                ...styles,
                color: `rgba(${colorsSecondary},0.8)`,
                //paddingInline: '15px',
                //paddingBlock: '5px',
              }),
              multiValueRemove: (styles) => ({
                ...styles,
                borderRadius: '10px',
              }),
              placeholder: (defaultStyles) => ({
                ...defaultStyles,
                color: `rgba(${colorsSecondary},0.36)`,
                fontWeight: 'normal',
                letterSpacing: '0.5px',
              }),
            }}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary: '#2050ec',
              },
            })}
            isOptionDisabled={(option) =>
              option.disabled === true || option.isDisabled === true
            }
            components={{
              MenuList: CustomMenuList,
              SingleValue: CustomSingleValue,
              MultiValue: CustomMultiValue,
            }}
            placeholder={placeholder}
            menuPlacement='auto'
            isSearchable={true}
            isClearable={clearable}
            options={options}
            value={selectedOption}
            isMulti={isMulti}
            onChange={handleSelected}
            tabIndex={tabIndex}
            ref={inputref}
            onKeyDown={(event) => {
              handleAction?.(event);
              handleKeyPress(event);
              if (event.key === 'Backspace' && inputValue === '') {
                event.stopPropagation();
                event.preventDefault();
              }
            }}
            onMenuClose={handleBlurAction}
            onBlur={handleBlur}
            //inputValue={inputValue}
            onInputChange={(value) => {
              if (!regex) {
                setInputValue(value);
                setregexError('');
              } else {
                if (
                  regexType === 'Lowercase' ||
                  regexType === 'LowercasewithNumeric'
                ) {
                  value = value.toLowerCase();
                }
                if (value === '' || regex.test(value)) {
                  setregexError('');
                  setInputValue(value);
                } else {
                  setregexError(
                    `Invalid input. Only ${regexType} characters are allowed.`
                  );
                }
              }
            }}
            menuPosition='fixed'
            id={id}
            isDisabled={disabled}
            noOptionsMessage={customNoOptionsMessage}
            className={className}
          />
          {textError && (
            <div className='error-inlinetext' role='alert' aria-atomic='true'>
              {textError?.length > 0 ? (
                typeof selectedOption != 'object' &&
                selectedOption?.length > 0 ? (
                  <>{`Please ${placeholder}`}</>
                ) : (
                  <>{textError}</>
                )
              ) : (
                <>{textError}</>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DropDown;
